import { Box, Paper, styled, SxProps, Theme } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';

interface ContentCardProps {
    contentMaxWidth?: 'sm' | 'md' | 'lg' | 'xl';
    sx?: SxProps<Theme>;
}

const ContentCard = forwardRef<HTMLDivElement, PropsWithChildren<ContentCardProps>>(({
    children,
    contentMaxWidth,
    sx
}, ref) => {
    if (contentMaxWidth) {
        return (
            <Root ref={ ref }
                sx={ sx }
                elevation={ 2 }>
                <Box maxWidth={ contentMaxWidth }
                    margin="0 auto">
                    { children }
                </Box>
            </Root>
        );
    }

    return (
        <Root ref={ ref }
            sx={ sx }
            elevation={ 2 }>
            { children }
        </Root>
    );
});

export default ContentCard;

const Root = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(5),
    // borderShadow: 'none',
    // boxShadow: 'none',
    // border: `1px solid ${ theme.palette.divider }`,
    height: 'fit-content',
    width: '100%',
    margin: '0 auto'
}));
